import initialStore from '../initialStore';
import { AuthStore } from '../../types/auth';
import { AuthAction } from '../../types/actions';

export const filesReducer = (currentState: AuthStore, action: AuthAction) => {
  switch (action.type) {
  case 'GET_FILES_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      allFiles: [],
      error: null
    });
  case 'GET_FILES_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      allFiles: action
    });
  case 'GET_FILES_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  case 'GET_FILE_VIEW_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      singleFile: [],
      error: null
    });
  case 'GET_FILE_VIEW_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      singleFile: action
    });
  case 'GET_FILE_VIEW_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  default:
    return currentState || initialStore.resources;
  }
};

export const getFileThumbReducer = (currentState: AuthStore, action: AuthAction) => {
  switch (action.type) {
  case 'GET_RESOURCE_THUMBNAIL_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      data: [],
      error: null
    });
  case 'GET_RESOURCE_THUMBNAIL_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      data: action.file
    });
  case 'GET_RESOURCE_THUMBNAIL_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  default:
    return currentState || initialStore.fileThumb;
  }
};


// WEBPACK FOOTER //
// ./src/store/reducers/files.js